import { getDocumentDecorator } from 'store/utils';
import {
  DispatcherAuthPrefix,
  DispatcherCategoryService,
  DispatcherEndpoint,
  DispatcherResource
} from 'modules/types/common';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';

export const GET_DOCUMENTS = 'HIPAA_DOCUMENTS.GET_DOCUMENTS';
export const GET_DOCUMENTS_SUCCESS = 'HIPAA_DOCUMENTS.GET_DOCUMENTS_SUCCESS';
export const GET_DOCUMENTS_FAIL = 'HIPAA_DOCUMENTS.GET_DOCUMENTS_FAIL';
export const getHipaaDocuments = () => {
  return {
    type: GET_DOCUMENTS,
    payload: {
      client: 'dispatcher',
      request: {
        method: 'get',
        url: getDispatcherUrl(
          DispatcherCategoryService.HEALTH_RECORDS,
          DispatcherAuthPrefix.AUTHENTICATED,
          DispatcherResource.HIPAA,
          DispatcherEndpoint.LATEST
        )
      }
    }
  };
};

export const GET_DOCUMENT = 'HIPAA_DOCUMENTS.GET_DOCUMENT';
export const GET_DOCUMENT_SUCCESS = 'HIPAA_DOCUMENTS.GET_DOCUMENT_SUCCESS';
export const GET_DOCUMENT_FAIL = 'HIPAA_DOCUMENTS.GET_DOCUMENT_FAIL';
export const getHipaaDocument = (acceptType: string, documentId: string) =>
  getDocumentDecorator(GET_DOCUMENT)(documentId, acceptType);

export const RESET_DOCUMENTS = 'HIPAA_DOCUMENTS.RESET_DOCUMENTS';
export const resetHipaaDocuments = () => ({ type: RESET_DOCUMENTS });
